<div class="module-whatsapp" (click)="open()">
    <div class="content">
        <div class="header">
            <div class="icon-left">
                <i class="fa-brands fa-whatsapp"></i>
            </div>   
            <div class="text"> 
                <strong>AJUDA ESPECIALIZADA</strong>
                <span>Fale com a gente</span> 
            </div>
        </div>
    </div>   
</div>    
